export class Carousel {

    /*
    * Init the handler
    */
   constructor() {
        let autoPlay = false;
        if($('.cover-block__carousel').data('autoplay')) {
            autoPlay = $('.cover-block__carousel').data('autoplay');
        }
        $('.cover-block__carousel').flickity({
            prevNextButtons: false,
            pauseAutoPlayOnHover: false,
            autoPlay: autoPlay,
            on: {
                ready: function() {
                    // resize to max cell height
                    let items  = this.$element[0].querySelectorAll('.cover-block'),
                    maxHeight = this.maxCellHeight
                    items.forEach(element => element.style.height = maxHeight + 'px');
                }
            }
        });
        $('.history-section__carousel').flickity({
            wrapAround: true,
            // groupCells: true,
            on: {
                ready: function() {
                    // resize to max cell height
                    let items  = this.$element[0].querySelectorAll('.history_section__timeline'),
                    maxHeight = this.maxCellHeight
                    items.forEach(element => element.style.height = maxHeight + 'px');
                }
            }
        });
   }
}
